<template>
  <div class="d-flex flex-column flex-root" @click="checkClickOutside">
    <!--begin::Page-->
    <div class="page">
      <!--begin::Aside-->
      <!--end::Aside-->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" class="header">
          <!--begin::Container-->
          <div
              class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
              id="kt_header_container"
          >
            <!--begin::Page title-->
            <div
                class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
            >
              <!--begin::Heading-->
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">
                Danh sách tác giả
              </h1>
              <!--end::Heading-->
            </div>
            <!--end::Page title=-->
            <!--begin::Wrapper-->
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <!--begin::Aside mobile toggle-->
              <div
                  class="btn btn-icon btn-active-icon-primary"
                  id="kt_aside_toggle"
              >
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1 mt-1">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                  >
                    <path
                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3"
                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                        fill="black"
                    />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Aside mobile toggle-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Container-->
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <div
            class="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <!--begin::Navbar-->
            <!--end::Container-->
            <div class="author-page">
              <!-- Thanh công cụ -->
              <div class="author-toolbar">
                <div class="author-toolbar__row">
                  <div class="author-search">
                    <i class="bi bi-search"></i>
                    <input type="text" v-model="body.name" placeholder="Tìm theo tên tác giả…"
                           @keyup.enter="search()"/>
                    <button v-if="body.name" class="author-search__clear" @click="body.name = null; search()"
                            title="Xoá">
                      <i class="bi bi-x-lg"></i>
                    </button>
                  </div>
                  <button class="btn btn-primary author-toolbar__btn" type="button" @click="search()">
                    Tìm kiếm
                  </button>
                  <div class="author-toolbar__total">
                    Tổng số <b>{{ $numberFormat(items.metaData.total || 0) }}</b> tác giả
                  </div>
                </div>
                <div class="author-filters">
                  <button v-for="f in stateFilters" :key="f.value || 'all'"
                          class="author-filter" :class="['author-filter--' + f.key, {'is-active': !body.reviewRequested && (body.stateList || null) === f.value}]"
                          @click="setState(f.value)">
                    <span class="author-filter__dot"></span>{{ f.label }}
                  </button>
                  <button class="author-filter author-filter--review" :class="{'is-active': body.reviewRequested}"
                          @click="setReviewRequested()">
                    <i class="bi bi-unlock"></i> Yêu cầu mở khoá
                  </button>
                </div>
              </div>

              <!-- Danh sách -->
              <div v-if="isLoading" class="author-state-box">
                <span class="spinner-border text-primary"></span>
              </div>
              <div v-else-if="!items.data || items.data.length === 0" class="author-state-box">
                <i class="bi bi-person-x fs-1"></i>
                <div>Không có tác giả nào</div>
              </div>
              <div v-else class="author-grid">
                <template v-for="(item, index) in items.data" :key="item.id || index">
                <div class="author-item" :class="'author-item--' + stateInfo(item.state).key">
                  <!-- Đầu thẻ: avatar + tên + trạng thái -->
                  <div class="author-item__head">
                    <div class="author-item__avatar">
                      <img
                          :src="item.image ? $getImage(item.image) : require('@/assets/images/MotTruyen_LogoApp1.png')"
                          alt="author"
                      />
                    </div>
                    <div class="author-item__title">
                      <div class="author-item__name">
                        <AuthorName :showVerify="true" :author="item"/>
                      </div>
                      <div class="author-item__id">#{{ item.id }}</div>
                    </div>
                    <span class="author-item__state">
                      <i class="bi" :class="stateInfo(item.state).icon"></i>
                      {{ stateInfo(item.state).label }}
                    </span>
                  </div>

                  <!-- Thông tin -->
                  <ul class="author-item__info">
                    <li :title="item.user?.email">
                      <i class="bi bi-envelope"></i>
                      <span class="text-truncate">{{ item.user?.email || '—' }}</span>
                    </li>
                    <li>
                      <i class="bi bi-people"></i>
                      <span><b>{{ $numberFormat(item.countFollower || 0) }}</b> người theo dõi</span>
                    </li>
                    <li v-if="item.user?.refUserId">
                      <i class="bi bi-person-plus"></i>
                      <span>Người giới thiệu: #{{ item.user.refUserId }}</span>
                    </li>
                    <li>
                      <i class="bi bi-clock-history"></i>
                      <span>Cập nhật {{ $formatDateTime(item.updatedAt) }}</span>
                    </li>
                  </ul>

                  <!-- Yêu cầu mở khoá đang chờ -->
                  <div v-if="item.reviewRequestedAt" class="author-item__review">
                    <div class="author-item__review-title">
                      <i class="bi bi-unlock-fill"></i> Gửi duyệt lại · {{ $formatDateTime(item.reviewRequestedAt) }}
                    </div>
                    <div class="author-item__review-note">{{ item.reviewRequestNote }}</div>
                  </div>

                  <!-- Hành động -->
                  <div class="author-item__actions">
                    <button class="btn btn-sm btn-light-primary" @click="showDetail(item)">
                      <i class="bi bi-eye"></i> Chi tiết
                    </button>
                    <template v-if="item.state === 'PENDING'">
                      <button class="btn btn-sm btn-success" @click="showModal(item.id, 'ACTIVE')">
                        <i class="bi bi-check-lg"></i> Duyệt
                      </button>
                      <button class="btn btn-sm btn-light-danger" @click="showModal(item.id, 'REJECT')">
                        <i class="bi bi-x-lg"></i> Từ chối
                      </button>
                    </template>
                    <template v-else-if="item.reviewRequestedAt">
                      <button class="btn btn-sm btn-success" @click="showModal(item.id, 'ACTIVE')">
                        <i class="bi bi-unlock"></i> Duyệt mở khoá
                      </button>
                      <button class="btn btn-sm btn-light-danger" @click="showRejectReview(item.id)">
                        <i class="bi bi-x-lg"></i> Từ chối
                      </button>
                    </template>
                    <template v-else>
                      <button v-if="item.state === 'LOCKED'" class="btn btn-sm btn-light-success"
                              @click="showModal(item.id, 'ACTIVE')">
                        <i class="bi bi-unlock"></i> Mở khoá
                      </button>
                      <button v-else-if="item.state !== 'BLOCK'" class="btn btn-sm btn-light-warning"
                              @click="showModal(item.id, 'LOCKED')">
                        <i class="bi bi-lock"></i> Khoá
                      </button>
                      <button v-if="item.state !== 'BLOCK'" class="btn btn-sm btn-light-danger"
                              @click="showModal(item.id, 'BLOCK')" title="Khoá vĩnh viễn">
                        <i class="bi bi-slash-circle"></i> Khoá vĩnh viễn
                      </button>
                    </template>
                    <router-link class="btn btn-sm btn-icon btn-light author-item__link"
                                 :to="{name: 'author_email', query: {ids: item.id}}" title="Gửi email cho tác giả này">
                      <i class="bi bi-envelope"></i>
                    </router-link>
                    <a class="btn btn-sm btn-icon btn-light author-item__link"
                       :href="$webUrl('tac-gia', item.name, item?.id)"
                       target="_blank" rel="noopener" title="Xem trang tác giả trên website">
                      <i class="bi bi-box-arrow-up-right"></i>
                    </a>
                  </div>
                </div>
                </template>
              </div>

              <!-- Phân trang -->
              <div class="author-pager" v-if="totalPage > 1">
                <div class="author-pager__info">
                  Trang {{ currentPage }} / {{ totalPage }}
                </div>
                <div class="author-pager__pages">
                  <button class="author-pager__btn" :disabled="currentPage <= 1" @click="goPage(currentPage - 1)">
                    <i class="bi bi-chevron-left"></i>
                  </button>
                  <template v-for="(p, i) in pageList" :key="i">
                    <span v-if="p === '…'" class="author-pager__dots">…</span>
                    <button v-else class="author-pager__btn" :class="{'is-active': p === currentPage}" @click="goPage(p)">
                      {{ p }}
                    </button>
                  </template>
                  <button class="author-pager__btn" :disabled="currentPage >= totalPage" @click="goPage(currentPage + 1)">
                    <i class="bi bi-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <!--end::Row-->
          </div>
          <!--end::Container-->
        </div>
      </div>
      <!--end::Wrapper-->
    </div>
    <b-modal v-model="isModalVisible" hide-footer="" ref="approved-author-modal" modal-class="approved-modal">
      <div class="fw-bold mb-2">{{ modalTitle }}</div>
      <div>Lời nhắn</div>
      <textarea name="" v-model="approvedBody.note" id="" rows="10" class="form-control">

      </textarea>
      <button class="btn btn-secondary mt-2 me-3" @click="isModalVisible = false">Đóng</button>
      <button class="btn btn-primary mt-2" @click="rejectingReview ? rejectReview() : changeState()">Xác nhận</button>
    </b-modal>

    <b-modal v-model="modalDetail" hide-footer="" ref="detail-modal" modal-class="detail-modal">
      <div v-if="itemDetail != null">
        <div>
          <a href="" class="symbol symbol-100px">
            <img
                class="symbol-label"
                :src="$getImage(itemDetail.image)"
                alt=""
                v-if="itemDetail.image != null"
            />
            <img
                src="@/assets/images/MotTruyen_LogoApp1.png"
                alt=""
                v-else
            />
          </a>
        </div>
        <div class="mt-2"><span class="fw-bold fw-bolder">Tên: </span>
          <AuthorName :showVerify="true" :author="itemDetail"/>
        </div>
        <div class="mt-2"><span class="fw-bold fw-bolder">Trạng thái: </span> {{ itemDetail.state }}</div>

        <div class="fw-bold fw-bolder">Bio:</div>
        <div v-html="itemDetail.description"></div>

        <div class="fw-bold fw-bolder mt-2">Loại:</div>
        <div>{{ itemDetail.type }}</div>
        <div v-if="itemDetail.authorApplication != null">
          <div class="fw-bold fw-bolder mt-2">Nguồn:</div>
          <div>{{ itemDetail.authorApplication.source }}</div>

          <div class="fw-bold fw-bolder mt-2">Quảng bá:</div>
          <div>{{ itemDetail.authorApplication.promotionalChannel }}</div>

          <div class="fw-bold fw-bolder mt-2">Kinh nghiệm:</div>
          <div>{{ itemDetail.authorApplication.experience }}</div>

          <div class="fw-bold fw-bolder mt-2">Giới thiệu:</div>
          <div v-html="itemDetail.introductionAdmin"></div>
        </div>

        <div v-if="itemDetail.reviewRequestedAt" class="author-detail-review mt-3">
          <div class="fw-bold fw-bolder">Yêu cầu mở khoá ({{ $formatDateTime(itemDetail.reviewRequestedAt) }}):</div>
          <div>{{ itemDetail.reviewRequestNote }}</div>
        </div>

        <div class="fw-bold fw-bolder mt-2">Lời nhắn cho tác giả:</div>
        <div v-html="itemDetail.adminGreeting"></div>
        <div class="mt-2">
          <button class="btn btn-sm btn-secondary me-3" @click="modalDetail = false">Đóng</button>
          <!--                        <button class="btn btn-sm btn-primary me-1" @click="changeState(item.id, 'APPROVED')">Chi tiết</button>-->
          <button
              v-if="itemDetail.state === 'PENDING'"
              class="btn btn-sm btn-success me-1 float-end"
              @click="showModal(itemDetail.id, 'ACTIVE')"
          >
            Duyệt
          </button>
          <button
              v-if="itemDetail.state === 'PENDING'"
              class="btn btn-sm btn-danger me-1 float-end"
              @click="showModal(itemDetail.id, 'REJECT')"
          >
            Từ chối
          </button>
        </div>
      </div>

    </b-modal>
  </div>
</template>
<script>
import requestUtil from "@/utils/request-util";
import AuthorName from "@/components/authors/AuthorName.vue";
import {BModal} from "bootstrap-vue-3";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Author",
  components: {BModal, AuthorName},
  data() {
    return {
      isLoading: false,
      isModalVisible: false,
      modalDetail: false,
      rejectingReview: false,
      approvedBody: {
        id: null,
        state: null,
        note: null,
      },
      body: {
        name: null,
        stateList: null,
        reviewRequested: null,
        sort: "updatedAt,desc",
        page: 0,
        size: 20,
      },
      itemDetail: null,
      items: {
        data: [],
        metaData: {
          page: 0,
          size: 20,
          totalPage: 0,
          total: 0,
          sort: "createdAt,desc",
        },
      },
    };
  },
  computed: {
    stateFilters() {
      return [
        {value: null, key: 'all', label: 'Tất cả'},
        {value: 'PENDING', key: 'pending', label: 'Chờ duyệt'},
        {value: 'ACTIVE', key: 'active', label: 'Hoạt động'},
        {value: 'READ_ONLY', key: 'readonly', label: 'Chỉ đọc'},
        {value: 'LOCKED', key: 'locked', label: 'Tạm khoá'},
        {value: 'INACTIVE', key: 'inactive', label: 'Riêng tư'},
        {value: 'REJECT', key: 'reject', label: 'Từ chối'},
        {value: 'BLOCK', key: 'block', label: 'Khoá vĩnh viễn'},
      ];
    },
    modalTitle() {
      if (this.rejectingReview) return 'Từ chối yêu cầu mở khoá (tác giả vẫn bị tạm khoá, có thể gửi lại)';
      const map = {ACTIVE: 'Duyệt / mở khoá tài khoản', REJECT: 'Từ chối đăng ký', LOCKED: 'Tạm khoá tài khoản', BLOCK: 'Khoá vĩnh viễn'};
      return map[this.approvedBody.state] || '';
    },
    totalPage() {
      const m = this.items.metaData || {};
      return m.totalPage || m.totalPages || Math.ceil((m.total || 0) / (this.body.size || 20));
    },
    currentPage() {
      return (this.body.page || 0) + 1;
    },
    /** Danh sách số trang hiển thị: 1 … 4 5 6 … 166 */
    pageList() {
      const total = this.totalPage, cur = this.currentPage, out = [];
      const add = (p) => out.push(p);
      const from = Math.max(2, cur - 2), to = Math.min(total - 1, cur + 2);
      add(1);
      if (from > 2) add('…');
      for (let p = from; p <= to; p++) add(p);
      if (to < total - 1) add('…');
      if (total > 1) add(total);
      return out;
    },
  },
  mounted() {
    this.fetchItems();
  },
  unmounted() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  created() {
  },
  methods: {
    stateInfo(state) {
      const map = {
        ACTIVE: {key: 'active', label: 'Hoạt động', icon: 'bi-check-circle-fill'},
        PENDING: {key: 'pending', label: 'Chờ duyệt', icon: 'bi-hourglass-split'},
        READ_ONLY: {key: 'readonly', label: 'Chỉ đọc', icon: 'bi-book-half'},
        LOCKED: {key: 'locked', label: 'Tạm khoá', icon: 'bi-lock-fill'},
        INACTIVE: {key: 'inactive', label: 'Riêng tư', icon: 'bi-eye-slash-fill'},
        REJECT: {key: 'reject', label: 'Từ chối', icon: 'bi-x-circle-fill'},
        BLOCK: {key: 'block', label: 'Khoá vĩnh viễn', icon: 'bi-slash-circle-fill'},
      };
      return map[state] || {key: 'other', label: state || '—', icon: 'bi-question-circle-fill'};
    },
    async fetchItems() {
      this.isLoading = true;
      try {
        const params = {
          ...this.body,
          name: this.body.name || null,
          stateList: this.body.stateList || null,
          reviewRequested: this.body.reviewRequested || null,
        };
        const response = await requestUtil.get("/admin/author", params);
        if (response.status === 200) {
          this.items = response.data;
        }
      } finally {
        this.isLoading = false;
      }
    },
    search() {
      this.body.page = 0;
      this.fetchItems();
    },
    setState(value) {
      this.body.stateList = value;
      this.body.reviewRequested = null;
      this.search();
    },
    setReviewRequested() {
      this.body.stateList = null;
      this.body.reviewRequested = true;
      this.search();
    },
    showRejectReview(id) {
      this.approvedBody.id = id;
      this.approvedBody.state = null;
      this.approvedBody.note = null;
      this.rejectingReview = true;
      this.isModalVisible = true;
    },
    async rejectReview() {
      try {
        const response = await requestUtil.post("/admin/author/review/_reject", {
          id: this.approvedBody.id,
          note: this.approvedBody.note,
        });
        if (response.status === 200) {
          this.$notify({title: "Đã từ chối yêu cầu mở khoá", type: "success"});
          await this.fetchItems();
        } else {
          this.$notify({title: response.data?.message || "Có lỗi xảy ra", type: "warning"});
        }
      } catch (e) {
        this.$notify({title: "Có lỗi xảy ra", type: "warning"});
      }
      this.isModalVisible = false;
      this.modalDetail = false;
    },
    goPage(page) {
      if (page < 1 || page > this.totalPage || page === this.currentPage) return;
      this.body.page = page - 1;
      this.fetchItems();
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async showDetail(item) {
      this.itemDetail = item;
      this.modalDetail = true;
    },
    async changeState() {
      console.log(this.approvedBody);
      const response = await requestUtil.post(
          "/admin/author/change_status",
          this.approvedBody
      );
      if (response.status === 200) {
        this.$notify({
          title: "Thành công",
          type: "success",
        });
        await this.fetchItems();
      } else {
        this.$notify({
          title: "Có lỗi xảy ra",
          type: "warning",
        });
      }
      this.isModalVisible = false;
      this.modalDetail = false;
    },
    async showModal(id, status) {
      this.rejectingReview = false;
      this.approvedBody.id = id;
      this.approvedBody.state = status;
      this.isModalVisible = true;
    },
  },
};
</script>
<style>
.menu-sub-dropdown {
  position: absolute;
  z-index: 10000;
}

.banner {
  border-radius: 20px;
  overflow: hidden;
}

.nav-tabs {
  .nav-item {
    color: #a1a5b7;
    border: 0;
    border-bottom: 1px solid transparent;
    transition: color 0.2s ease, background-color 0.2s ease;
    padding: 0.5rem 0;
    margin: 0 1rem;
    display: flex;
    align-items: stretch;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 1.15rem !important;
    background: none;

    .nav-link {
      background: none !important;
      color: #5e6278;
      font-weight: 600 !important;
      border: none;
    }

    .active {
      border-bottom: 3px solid #009ef7 !important;
      color: #009ef7 !important;
    }
  }
}

.modal.detail-modal {
  z-index: 1050 !important;
}

.modal.approved-modal {
  z-index: 1061 !important; /* cao hơn modal detail */
}
</style>

<style scoped>
/* ================= Trang ================= */
.author-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 24px;
}

/* ================= Thanh công cụ ================= */
.author-toolbar {
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  box-shadow: 0 1px 3px rgba(24, 28, 50, .06);
}
.author-toolbar__row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}
.author-search {
  position: relative;
  flex: 0 1 360px;
  min-width: 220px;
}
.author-search > i {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #a1a5b7;
}
.author-search input {
  width: 100%;
  height: 40px;
  padding: 0 36px 0 40px;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  background: #f9f9fb;
  font-size: 14px;
  outline: none;
  transition: border-color .15s ease, background-color .15s ease;
}
.author-search input:focus {
  border-color: #1b84ff;
  background: #fff;
}
.author-search__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #a1a5b7;
  padding: 4px;
}
.author-toolbar__btn {
  height: 40px;
  padding: 0 20px !important;
}
.author-toolbar__total {
  margin-left: auto;
  font-size: 14px;
  color: #7e8299;
}
.author-toolbar__total b {
  color: #181c32;
}

/* Bộ lọc trạng thái */
.author-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #f1f1f4;
}
.author-filter {
  --st: #7e8299;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border: 1px solid #e4e6ef;
  border-radius: 16px;
  background: #fff;
  color: #5e6278;
  font-size: 13px;
  font-weight: 500;
  transition: all .15s ease;
}
.author-filter__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--st);
}
.author-filter:hover {
  border-color: var(--st);
  color: #181c32;
}
.author-filter.is-active {
  background: var(--st);
  border-color: var(--st);
  color: #fff;
}
.author-filter.is-active .author-filter__dot {
  background: #fff;
}
.author-filter--all { --st: #1b84ff; }

/* ================= Màu theo trạng thái (dùng chung thẻ + bộ lọc) ================= */
.author-item.author-item--active,   .author-filter--active   { --st: #17c653; --st-bg: #f3fcf6; }
.author-item.author-item--pending,  .author-filter--pending  { --st: #e9a800; --st-bg: #fffaea; }
.author-item.author-item--readonly, .author-filter--readonly { --st: #7239ea; --st-bg: #f7f3ff; }
.author-item.author-item--locked,   .author-filter--locked   { --st: #f17a00; --st-bg: #fff6ec; }
.author-item.author-item--inactive, .author-filter--inactive { --st: #5e6278; --st-bg: #f6f7fa; }
.author-item.author-item--reject,   .author-filter--reject   { --st: #f1416c; --st-bg: #fff2f5; }
.author-item.author-item--block,    .author-filter--block    { --st: #8b1e3f; --st-bg: #fbf0f3; }

/* ================= Lưới thẻ ================= */
.author-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}
.author-state-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 60px 16px;
  background: #fff;
  border-radius: 12px;
  color: #a1a5b7;
}

/* ================= Thẻ tác giả: màu thẻ = màu trạng thái ================= */
.author-item {
  --st: #a1a5b7;
  --st-bg: #f9f9fb;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 18px 16px 14px;
  background: var(--st-bg);
  border: 1px solid color-mix(in srgb, var(--st) 35%, #fff);
  border-radius: 12px;
  overflow: hidden;
  transition: box-shadow .15s ease, transform .15s ease;
}
/* Vạch màu trạng thái ở đầu thẻ */
.author-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--st);
}
.author-item:hover {
  box-shadow: 0 8px 22px rgba(24, 28, 50, .10);
  transform: translateY(-2px);
}

.author-item__head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.author-item__avatar {
  flex: 0 0 52px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--st);
}
.author-item__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.author-item__title {
  flex: 1;
  min-width: 0;
}
.author-item__name {
  font-size: 15px;
  font-weight: 600;
  color: #181c32;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.author-item__id {
  margin-top: 2px;
  font-size: 12px;
  color: #a1a5b7;
}
.author-item__state {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  background: var(--st);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.author-item__info {
  list-style: none;
  margin: 14px 0 0;
  padding: 12px 0 0;
  border-top: 1px dashed color-mix(in srgb, var(--st) 30%, transparent);
  font-size: 13px;
  color: #5e6278;
  flex: 1;
}
.author-item__info li {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 3px 0;
}
.author-item__info i {
  flex: 0 0 16px;
  color: var(--st);
}

.author-item__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid color-mix(in srgb, var(--st) 22%, transparent);
}
.author-item__actions .btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px !important;
  font-size: 12px;
  background-color: #fff;
}
.author-item__actions .btn-success {
  background-color: #17c653;
}
.author-item__link + .author-item__link {
  margin-left: 0;
}
.author-item__link {
  margin-left: auto;
  width: 30px;
  height: 30px;
  padding: 0 !important;
  justify-content: center;
}

/* ================= Phân trang ================= */
.author-pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  background: #fff;
  border-radius: 12px;
}
.author-pager__info {
  font-size: 13px;
  color: #7e8299;
}
.author-pager__pages {
  display: flex;
  align-items: center;
  gap: 4px;
}
.author-pager__btn {
  min-width: 34px;
  height: 34px;
  padding: 0 8px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #5e6278;
  font-weight: 600;
  font-size: 13px;
}
.author-pager__btn:hover:not(:disabled) {
  background: #f1f1f4;
}
.author-pager__btn.is-active {
  background: #1b84ff;
  color: #fff;
}
.author-pager__btn:disabled {
  opacity: .4;
}
.author-pager__dots {
  padding: 0 4px;
  color: #a1a5b7;
}

@media (max-width: 767.98px) {
  .author-toolbar__total {
    margin-left: 0;
    width: 100%;
  }
  .author-search {
    flex: 1 1 100%;
  }
  .author-grid {
    grid-template-columns: 1fr;
  }
  .author-pager {
    justify-content: center;
  }
}

/* ===== Yêu cầu mở khoá ===== */
.author-filter.author-filter--review { --st: #1b84ff; }
.author-item__review {
  margin-top: 4px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #eef6ff;
  border: 1px dashed #9cc7ff;
}
.author-item__review-title {
  font-size: 12px;
  font-weight: 700;
  color: #1b5fae;
  margin-bottom: 4px;
}
.author-item__review-note {
  font-size: 13px;
  color: #3f4254;
  white-space: pre-line;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.author-detail-review {
  padding: 10px 12px;
  border-radius: 10px;
  background: #eef6ff;
  white-space: pre-line;
}
</style>
